export const styles = {
  filterSearchWrapper: {
    margin: '0 65px 0 40px',
  },
  filterWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',

    '&>div': {
      paddingLeft: '30px',
    },
  },
  pagination: {
    margin: '0 40px',
  },
  actionsCell: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spy/List/style.js